/**
 * 사업자 정보 (전자상거래법 13조 — 표시·광고 사항).
 * 약관/개인정보처리방침 페이지 하단 + 향후 footer 에 공통 사용.
 */
export function CompanyInfo() {
  return (
    <section className="card">
      <h2 className="text-sm font-bold text-text mb-3">회사 정보</h2>
      <dl className="grid grid-cols-[7rem_1fr] gap-y-1.5 text-[12px] text-text-sub">
        <dt className="font-medium text-text">상호</dt>
        <dd>트렌드레인</dd>
        <dt className="font-medium text-text">대표자</dt>
        <dd>김현경</dd>
        <dt className="font-medium text-text">사업자등록번호</dt>
        <dd>507-12-85992</dd>
        <dt className="font-medium text-text">통신판매업 신고</dt>
        <dd>제 2026-수원영통-0583 호</dd>
        <dt className="font-medium text-text">사업장 주소</dt>
        <dd>경기도 수원시 영통구 덕영대로 1400, 207동 504호 (망포동, 영통아이파크캐슬2단지)</dd>
        <dt className="font-medium text-text">고객센터</dt>
        <dd>010-9080-8434</dd>
        <dt className="font-medium text-text">이메일</dt>
        <dd>arsenium@naver.com</dd>
      </dl>
    </section>
  );
}
